
import { Professional } from '../types';

const AUTH_KEY = 'planstack_auth_user';

export interface User {
  email: string;
  name: string;
  isLoggedIn: boolean;
}

export const authService = {
  getUser(): User | null {
    const data = localStorage.getItem(AUTH_KEY);
    return data ? JSON.parse(data) : null;
  },

  setUser(user: User) {
    localStorage.setItem(AUTH_KEY, JSON.stringify(user));
    // Dispatch custom event for real-time header updates
    window.dispatchEvent(new Event('authChange'));
  },

  async login(email: string, password: string): Promise<{ success: boolean; error?: string }> {
    // In a real app, this would call Supabase Auth or a backend
    // For this demo/local version, we accept any valid email
    if (!email.includes('@')) return { success: false, error: 'Invalid email address' };
    
    const user: User = {
      email,
      name: email.split('@')[0],
      isLoggedIn: true
    };
    
    this.setUser(user);
    return { success: true };
  },

  async signup(email: string, password: string, name: string): Promise<{ success: boolean; error?: string }> {
    if (!email.includes('@')) return { success: false, error: 'Invalid email address' };
    
    const user: User = {
      email,
      name,
      isLoggedIn: true
    };
    
    this.setUser(user);
    return { success: true };
  },

  logout() {
    localStorage.removeItem(AUTH_KEY);
    window.dispatchEvent(new Event('authChange'));
  },

  isAuthenticated(): boolean {
    return !!this.getUser();
  }
};
